import { Alert } from '@vnetwork/ui/feedback';
import { Button, Card, Skeleton } from '@vnetwork/ui/primitives';

/** Danger Alert with a Retry action — shared across the detail tables. */
export function TabError({ title, onRetry }: { title: string; onRetry: () => void }) {
  return (
    <Alert
      tone="danger"
      title={title}
      actions={
        <Button size="sm" variant="ghost" onClick={onRetry}>
          Retry
        </Button>
      }
    />
  );
}

/** Skeleton rows inside a flat Card — shared table loading placeholder. */
export function TabLoading({ rows = 6 }: { rows?: number }) {
  return (
    <Card flat>
      <div style={{ padding: 'var(--vn-space-4)', display: 'grid', gap: 'var(--vn-space-2)' }}>
        {Array.from({ length: rows }).map((_, i) => (
          <Skeleton key={i} style={{ height: 24 }} />
        ))}
      </div>
    </Card>
  );
}
